/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ContactEntry } from "./contact-entry";
import { ContactTel } from "./contact-tel";
import { ContactEmail } from "./contact-email";
import { ContactAddress } from "./contact-address";

export class Contact extends ContactEntry {
    name: string;
    jobTitle: string;
    telephoneNumbers: ContactTel[] = [];
    emails: ContactEmail[] = [];
    addresses: ContactAddress[] = [];
}
